export default {
    name: 'additional-materials',
    props: {
        list: {}
    }
}
